import React from 'react';
import useLockBody from '../../hooks/useLockBody';

function LockBody() {
  useLockBody();
  return <div className="hidden h-0 w-0 opacity-0 absolute" />;
}

export default LockBody;
